import { render } from "./SocialNews.vue?vue&type=template&id=bea64900"
import script from "./SocialNews.vue?vue&type=script&lang=js"
export * from "./SocialNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\PhuongVangDanh\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__